module.exports = __webpack_public_path__ + "img/inverter_purple.d7103a88.png";